import ExtBaseService from './ExtService'

const ApiExtService = {
    fetchData(param) {
        return new Promise((resolve, reject) => {
            ExtBaseService(param)
                .then((response) => {
                    resolve(response)
                })
                .catch((errors) => {
                    reject(errors)
                })
        })
    },
}

export default ApiExtService
